import { Route, Routes, useLocation } from 'react-router-dom';
import PersonalizedUpdates from '../components/billingcycle/billingstepper/PersonalizedUpdates';
import StartLearning from '../components/billingcycle/billingstepper/StartLearning';
import ErrorDisplay from '../components/common/error';
import CustomLogin from '../components/custom-login';
import About from '../components/pages/about';
import ClassOverview from '../components/pages/class-overview';
import CookieSetting from '../components/pages/cookies/CookieSetting';
import CourseDetail from '../components/pages/course-detail/CourseDetail';
import EditProfile from '../components/pages/edit-profile/EditProfile';
import HelpCenter from '../components/pages/help';
import Home from '../components/pages/home';
import Books from '../components/pages/library-overview/Books';
import Bulletins from '../components/pages/library-overview/Bulletins';
import DailyReminders from '../components/pages/library-overview/DailyReminders';
import Documents from '../components/pages/library-overview/Documents';
import Podcasts from '../components/pages/library-overview/Podcasts';
import Videos from '../components/pages/library-overview/Videos';
import MembershipFailure from '../components/pages/membership-failure';
import MembershipSuccess from '../components/pages/membership-success';
import PrivacyPolicy from '../components/pages/privacy-policy/PrivacyPolicy';
import Program from '../components/pages/program/Program';
import { SelectCurrency } from '../components/pages/select-currency/SelectCurrency';
import SelectMembership from '../components/pages/select-membership';
import UserSettings from '../components/pages/settings/';
import UpdatePassword from '../components/pages/settings/UpdatePassword';
import SignOut from '../components/pages/sign-out';
// import SignUp from '../components/pages/sign-up';
// import SocialSignin from '../components/pages/social-sign-in';
import RecomendedContent from '../components/pages/library-overview/RecomendedContent';
import SetupPassword from '../components/pages/setup-password';
// import SignUp from '../components/pages/sign-up';
import BookMarkSection from '../components/pages/stance-section/BookMarkSection';
import MystanceAllPrograms from '../components/pages/stance-section/MystanceAllPrograms';
import NotesSection from '../components/pages/stance-section/NotesSection';
import ProgramNotes from '../components/pages/stance-section/ProgramNotes';
import TermsOfServices from '../components/pages/terms-of-services';
import UserProfile from '../components/pages/user';
import VideoTutorialDetails from '../components/pages/video-tutorials/VideoTutorialDetails';
import VideoTutorials from '../components/pages/video-tutorials/VideoTutorials';
import ProgramOverView from '../components/program-overview/ProgramOverView';
import ResetPassword from '../components/reset-password';
import VerifyEmail from '../components/verifyemail';
import MainLayout from '../layouts/MainLayout';
import RootLayout from '../layouts/RootLayout';
import PrivateRoute from './PrivateRoute';
import Redirection from '../components/pages/redirection';
import LearnerRedirection from '../components/pages/learner-redirection';
  
function AppRoutes() {
const location=useLocation()
  return (
    <Routes>
      <Route
        path="/"
        element={<RootLayout showButton={true} showLanguageSelector={true}/>}
        children={[
          <>
            <Route path="/" element={<CustomLogin />} />
             {/* <Route path="/sign-up" element={<SignUp />} /> */}
            {/*<Route path="/social-sign-in" element={<SocialSignin />} /> */}
            <Route path="/sign-out" element={<SignOut />} />
            <Route path="/redirection" element={<Redirection />} />
            <Route path="/learner-redirection" element={<LearnerRedirection/>}/>

          </>,
        ]}
      />
      <Route
        path="/"
        element={<RootLayout showButton={false} showLanguageSelector={false}/>}
        children={[
          <> 
            <Route path="/setup-password" element={<SetupPassword />} />
            <Route path="/select-currency" element={<PrivateRoute component={SelectCurrency} />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verification/:type" element={<VerifyEmail />} />
            <Route
              path="/membership-success"
              element={<PrivateRoute component={MembershipSuccess} />}
            />
            <Route
              path="/start-learning"
              element={<StartLearning />}
            />
            <Route
              path="/personalized-updates"
              element={<PrivateRoute component={PersonalizedUpdates} />}
            />
            <Route
              path="/membership-failure"
              element={<PrivateRoute component={MembershipFailure} />}
            />
            <Route
              path="/profile"
              element={<PrivateRoute component={UserProfile} />}
            />
            <Route path="/membership-failure" element={<MembershipFailure />} />
            <Route
              path="/select-membership"
              element={<PrivateRoute component={SelectMembership} />}
            />
            <Route path="/error/:type" element={<ErrorDisplay />} />,
          </>,
        ]}
      />
      {/* main Layout routes goes here is children*/}
      <Route
        path="/"
        element={<MainLayout />}
        errorElement={<h1 />}
        children={[
          <>
            <Route
              path="/edit-profile"
              element={<PrivateRoute component={EditProfile} />}
            />
            <Route
              path="/user-settings/*"
              element={<PrivateRoute component={UserSettings} />}
            />
            <Route
              path="/update-password"
              element={<PrivateRoute component={UpdatePassword} />}
            />
            <Route
              path="/help"
              element={<PrivateRoute component={HelpCenter} />}
            />
            <Route
              path="/class-overview"
              element={<PrivateRoute component={ClassOverview} />}
            />
            <Route path="/home/*" element={<PrivateRoute component={Home} />} />
            <Route
              path="/program-overview"
              element={<PrivateRoute component={ProgramOverView} key={location.search} />}
            />
            <Route
              path="/program"
              element={<PrivateRoute component={Program} />}
            />
            <Route
              path="/videos/:id"
              element={<PrivateRoute component={Videos} />}
            />
            <Route
              path="/podcasts/:id"
              element={<PrivateRoute component={Podcasts} />}
            />
            <Route
              path="/bulletins/:id"
              element={<PrivateRoute component={Bulletins} />}
            />
            <Route
              path="/documents/:id"
              element={<PrivateRoute component={Documents} />}
            />
            <Route
              path="/books/:id"
              element={<PrivateRoute component={Books} />}
            />
            <Route
              path="/daily-reminders"
              element={<PrivateRoute component={DailyReminders} />}
            />
            <Route
              path="/video-tutorials"
              element={<PrivateRoute component={VideoTutorials} />}
            />
            <Route
              path="/video-tutorial-details/:courseId"
              element={<PrivateRoute component={VideoTutorialDetails} />}
            />
             <Route
              path="/recommended-content"
              element={<PrivateRoute component={RecomendedContent} />}
            />,
            <Route
              path="/program/:courseId"
              element={<PrivateRoute component={Program} />}
            />
            <Route
              path="/bookmark"
              element={<PrivateRoute component={BookMarkSection} />}
            />
            <Route
              path="/mystance-all-programs"
              element={<PrivateRoute component={MystanceAllPrograms} />}
            />
            <Route path="/about" element={<PrivateRoute component={About} />} />
            <Route
              path="/program-notes"
              element={<PrivateRoute component={ProgramNotes} />}
            />
            <Route
              path="/notes"
              element={<PrivateRoute component={NotesSection} />}
            />
            <Route
              path="/course-detail/:mainLearningProgramId/:learningProgramId/:courseId"
              element={<PrivateRoute component={CourseDetail} />}
            />
            {/* <Route
              path="/home/notification"
              element={<PrivateRoute component={Notification} />}
            /> */}
            <Route path="/terms-of-services" element={<TermsOfServices />} />,
            <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
            <Route path="/cookie-setting" element={<CookieSetting />}/>
          </>,
        ]}
      />
    </Routes>
  );
}

export default AppRoutes;
